{
    "en": {
        "meeting_id": "Meeting ID",
        "meeting_on": "Meeting on",
        "meeting_timing": "Timing",
        "meeting_desc": "Meeting description",
        "meeting_location": "Location",
        "meeting_type": "Type",
        "meeting_participants": "Participants",
        "actions": "Actions"
    },
    "de": {
        "meeting_id": "Besprechungs-ID",
        "meeting_on": "Besprechung am",
        "meeting_timing": "Zeitpunkt",
        "meeting_desc": "Besprechungsbeschreibung",
        "meeting_location": "Standort",
        "meeting_type": "Typ",
        "meeting_participants": "Teilnehmer",
        "actions": "Aktionen"
    },
    "sv": {
        "meeting_id": "MötesID",
        "meeting_on": "Möte på",
        "meeting_timing": "Tid",
        "meeting_desc": "Mötesbeskrivning",
        "meeting_location": "Plats",
        "meeting_type": "Typ",
        "meeting_participants": "Deltagare",
        "actions": "Åtgärder"
    },
    "ro": {
        "meeting_id": "ID întâlnire",
        "meeting_on": "Data întâlnirii",
        "meeting_timing": "Ora",
        "meeting_desc": "Descrierea întâlnirii",
        "meeting_location": "Locație",
        "meeting_type": "Tip",
        "meeting_participants": "Participanți",
        "actions": "Acțiuni"
    },
    "pl": {
        "meeting_id": "ID spotkania",
        "meeting_on": "Spotkanie w dniu",
        "meeting_timing": "Czas",
        "meeting_desc": "Opis spotkania",
        "meeting_location": "Lokalizacja",
        "meeting_type": "Typ",
        "meeting_participants": "Uczestnicy",
        "actions": "Działania"
    },
    "it": {
        "meeting_id": "ID riunione",
        "meeting_on": "Riunione il",
        "meeting_timing": "Orario",
        "meeting_desc": "Descrizione della riunione",
        "meeting_location": "Luogo",
        "meeting_type": "Tipo",
        "meeting_participants": "Partecipanti",
        "actions": "Azioni"
    },
    "nl": {
        "meeting_id": "Vergadering ID",
        "meeting_on": "Vergadering op",
        "meeting_timing": "Tijdstip",
        "meeting_desc": "Vergaderbeschrijving",
        "meeting_location": "Locatie",
        "meeting_type": "Type",
        "meeting_participants": "Deelnemers",
        "actions": "Acties"
    },
    "hu": {
        "meeting_id": "Találkozó ID",
        "meeting_on": "Találkozó időpontja",
        "meeting_timing": "Időzítés",
        "meeting_desc": "Találkozó leírása",
        "meeting_location": "Helyszín",
        "meeting_type": "Típus",
        "meeting_participants": "Résztvevők",
        "actions": "Műveletek"
    },
    "cz": {
        "meeting_id": "ID schůzky",
        "meeting_on": "Schůzka dne",
        "meeting_timing": "Časování",
        "meeting_desc": "Popis schůzky",
        "meeting_location": "Umístění",
        "meeting_type": "Typ",
        "meeting_participants": "Účastníci",
        "actions": "Akce"
    }
}
